export default __webpack_public_path__ + "static/media/Seal of Divertion.ab0d46b3.jpg";